import { useEffect, type PropsWithChildren } from "react";
import { ConfigProvider } from "antd";

import { applyAntdMobileTheme } from "../adapters/antd-mobile.ts";
import { applyTenantThemeRuntime } from "../runtime/create-runtime.ts";
import type { TenantThemeRuntime } from "../core/types.ts";
import { TenantThemeRuntimeContext } from "./context.ts";

export interface TenantThemeProviderProps extends PropsWithChildren {
  runtime: TenantThemeRuntime;
}

export function TenantThemeEffects({
  runtime,
  children,
}: TenantThemeProviderProps) {
  useEffect(() => {
    applyTenantThemeRuntime(runtime);
    applyAntdMobileTheme(runtime.antdMobileVars);
  }, [runtime]);

  return (
    <TenantThemeRuntimeContext.Provider value={runtime}>
      {children}
    </TenantThemeRuntimeContext.Provider>
  );
}

export function TenantThemeProvider({
  runtime,
  children,
}: TenantThemeProviderProps) {
  const mergedTheme = {
    ...runtime.antdTheme,
    components: {
      ...runtime.antdTheme.components,
      Select: {
        ...runtime.antdTheme.components?.Select,
        optionSelectedColor:
          runtime.antdTheme.components?.Select?.optionSelectedColor ??
          runtime.antdTheme.token?.colorPrimary ??
          runtime.brandTheme.primary,
        optionSelectedBg:
          runtime.antdTheme.components?.Select?.optionSelectedBg ??
          runtime.brandTheme.secondary,
      },
    },
  };

  return (
    <TenantThemeEffects runtime={runtime}>
      <ConfigProvider theme={mergedTheme}>{children}</ConfigProvider>
    </TenantThemeEffects>
  );
}
